export default __webpack_public_path__ + "static/media/sort-icon.9774e21e.svg";